import React from "react";
import { APP } from "../../constant/theme";

const Footer = ({ hideCopyright = false }) => {
  const credit = APP.developerCredit;

  return (
    <>
      <div className="footer">
        <div className="card icard">
          <div className="row">
            {!hideCopyright && (
              <div className="col-lg-6">
                <div className="copyright company">
                  <p style={{ fontSize: "15px" }}>{APP.copyright}</p>
                </div>
              </div>
            )}

            {credit?.show && (
              <div className={hideCopyright ? "col-12" : "col-lg-6"}>
                <div className={`copyright inno${hideCopyright ? " justify-content-center" : ""}`}>
                  <a
                    href={credit.url}
                    style={{ color: credit.color, fontSize: credit.fontSize }}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {credit.label} {credit.company}{" "}
                  </a>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
